export default "__VITE_ASSET__D2TAIyqr__";